import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axiosInstance from '../../api/axiosInstance';
import '../../pages/AdminCommon.css';

const Profile: React.FC = () => {
  const navigate = useNavigate();
  const [profile, setProfile] = useState<any>(null);
  const [nickname, setNickname] = useState('');
  const [bio, setBio] = useState('');
  const [message, setMessage] = useState('');
  const [isError, setIsError] = useState(false);

  useEffect(() => {
    axiosInstance.get('/api/auth/me').then(res => {
      setProfile(res.data);
      setNickname(res.data.nickname || '');
      setBio(res.data.bio || '');
    }).catch(err => {
      if (err.response?.status === 401) {
        navigate('/login');
      }
    });
  }, [navigate]);

  const handleUpdate = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      await axiosInstance.put('/api/auth/me', { nickname, bio });
      setIsError(false);
      setMessage('프로필이 성공적으로 수정되었습니다.');
      setTimeout(() => {
        navigate('/');
      }, 1500);
    } catch (err) {
      setIsError(true);
      setMessage('프로필 수정에 실패했습니다. 다시 시도해주세요.');
    }
  };

  if (!profile) {
    return (
      <div className="admin-page-wrapper" style={{ textAlign: 'center', padding: '48px 0' }}>
        <div style={{ color: 'var(--admin-text-muted)', fontSize: '16px' }}>사용자 정보를 불러오는 중입니다...</div>
      </div>
    );
  }

  return (
    <div className="admin-page-wrapper profile-card">
      <div className="profile-flex-container">
        <div className="profile-avatar-area">
          <div className="profile-avatar-circle">
            <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
              <circle cx="12" cy="7" r="4"></circle>
            </svg>
          </div>
          <div className="profile-avatar-title">{profile.nickname || profile.username}</div>
          <div className="profile-avatar-email">{profile.email}</div>
        </div>

        <div className="profile-form-area">
          <form onSubmit={handleUpdate}>
            {message && (
              <div className={`admin-alert ${isError ? 'admin-alert-danger' : 'admin-alert-success'}`}>
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ marginRight: '4px' }}>
                  {isError ? (
                    <>
                      <circle cx="12" cy="12" r="10"></circle>
                      <line x1="12" y1="8" x2="12" y2="12"></line>
                      <line x1="12" y1="16" x2="12.01" y2="16"></line>
                    </>
                  ) : (
                    <>
                      <polyline points="20 6 9 17 4 12"></polyline>
                    </>
                  )}
                </svg>
                {message}
              </div>
            )}

            <div className="admin-form-group">
              <label className="admin-label">사용자 아이디</label>
              <input 
                className="admin-input" 
                value={profile.username} 
                disabled 
                style={{ backgroundColor: '#f1f5f9', cursor: 'not-allowed', color: '#94a3b8' }} 
              />
            </div>

            <div className="admin-form-group">
              <label className="admin-label">이메일 주소</label>
              <input 
                className="admin-input" 
                value={profile.email} 
                disabled 
                style={{ backgroundColor: '#f1f5f9', cursor: 'not-allowed', color: '#94a3b8' }} 
              />
            </div>

            <div className="admin-form-group">
              <label className="admin-label">닉네임</label>
              <input 
                className="admin-input" 
                value={nickname} 
                onChange={e => setNickname(e.target.value)} 
                placeholder="사용하실 닉네임을 입력하세요" 
                required
              />
            </div>

            <div className="admin-form-group">
              <label className="admin-label">자기소개</label>
              <textarea 
                className="admin-textarea" 
                value={bio} 
                onChange={e => setBio(e.target.value)} 
                placeholder="자신을 소개할 수 있는 한 줄 메시지를 입력하세요" 
              />
            </div>

            <div style={{ marginTop: '32px', display: 'flex', gap: '12px' }}>
              <button 
                type="button" 
                className="admin-btn admin-btn-secondary" 
                style={{ flex: 1 }}
                onClick={() => navigate('/')}
              >
                취소
              </button>
              <button 
                type="submit" 
                className="admin-btn admin-btn-primary" 
                style={{ flex: 2 }}
              >
                정보 수정하기
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Profile;
